import React from 'react';
import { MdContentCopy as CopyIcon } from 'react-icons/md';
import { Body, Button } from '@walmart-web/livingdesign-components';

import styles from '../styles.module.css';
import StatusCard from '../../../../components/StatusCard/index.tsx';
import { FEDEX_TRACKING_LINK } from '../../../../constants/common.js';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

type Props = {
  status: string;
  trackingNumber: string;
};

const OnTheWayStatusCard: React.FC<Props> = ({ status, trackingNumber }) => {
  const { t } = useTranslation('ihut');

  const handleCopyClick = () => {
    navigator.clipboard.writeText(trackingNumber);
  };

  return (
    <StatusCard
      status={status}
      imgSrc="/assets/images/ihut/tracking.png"
      showTag
      tagProps={{
        variant: 'tertiary',
        color: 'blue',
        text: t('deliveryStatus.onTheWay')
      }}
    >
      <StatusCard.Heading>
        {t('shippingInfo.shipmentProgress')}
      </StatusCard.Heading>
      <StatusCard.Column>
        <Body size="small">{t('shippingInfo.trackingNumber')}</Body>
        <Body
          size="medium"
          UNSAFE_className={clsx(styles.bold, styles.textOverflow)}
        >
          {trackingNumber}
        </Body>
      </StatusCard.Column>
      <Button
        variant="tertiary"
        size="small"
        className={styles.copyButton}
        onClick={handleCopyClick}
        leading={<CopyIcon />}
      >
        {t('copy', { ns: 'common' })}
      </Button>
      <a
        href={`${FEDEX_TRACKING_LINK}${trackingNumber}`}
        target="_blank"
        className={styles.link}
        rel="noreferrer"
      >
        <Body size="small" UNSAFE_className={styles.textColor}>
          {t('shippingInfo.viewFedexTracking')}
        </Body>
      </a>
    </StatusCard>
  );
};

export default OnTheWayStatusCard;
